<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Reset Stop #{{ config.data.index + 1 }} for Ride </span>
      <span class="body-medium-medium text-light-color">#{{ config.data.id }}</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="content p-spacing-xl border-1 border-neutral-base-primary-border border-round-lg flex flex-column gap-spacing-xl table-bg-hover-bg">
  <form
    #form="ngForm"
    class="flex flex-column gap-spacing-xl">
    <div class="form-group flex flex-column gap-spacing-xs">
      <label
        class="input-label flex flex-column gap-spacing-default body-medium-medium text-secondary-color"
        for="reasonInput"
        >Reason
        <span class="body-small-medium text-caption-color">The reason why you are resetting this stop.</span>
      </label>
      <p-autoComplete
        #reasonInput="ngModel"
        #autoCompleteRef
        [(ngModel)]="reason"
        name="reason"
        required
        [suggestions]="filteredSuggestions"
        (completeMethod)="filterSuggestions($event, autoCompleteRef)"
        (onFocus)="filterSuggestions($event, autoCompleteRef)"
        [showEmptyMessage]="false"
        appendTo="body"
        inputStyleClass="px-spacing-md pt-spacing-md"
        [style]="{ width: '100%' }"
        [inputStyle]="{ paddingBottom: '72px', height: '100px' }"
        placeholder="Select or enter a reason." />
    </div>
  </form>
  <div class="warning-messages border-round-md p-spacing-md background-muted-warning-bg flex gap-spacing-xs align-items-center">
    <i class="icon-warning-solid text-xl icon-warning-color"></i>
    <ul class="mb-0 pl-spacing-2xl">
      <li class="label-large-regular text-warning-color">Resetting a stop will take it back to en route status and it will reset its passengers to the original status.</li>
      <li class="label-large-regular text-warning-color">All next stops will be reset to the original status as it was created.</li>
      <li class="label-large-regular text-warning-color">This action will notify the driver and any monitors via push notification.</li>
    </ul>
  </div>
</div>

<div class="footer pb-spacing-3xl pt-spacing-4xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
  <app-button
    label="Cancel"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
  <app-button
    label="Reset Stop"
    [isLoading]="loading"
    [disabled]="loading || !!form?.invalid || reasonInput.value?.trim().length <= 0"
    [iconStart]="loading ? 'icon-spinner-gap' : ''"
    (btnClick)="confirmAction(form)"
    sizeClass="p-button-md"
    severity="primary"></app-button>
</div>
